import { createSlice } from '@reduxjs/toolkit'
import getIssueDetail from '../../lib/api/dictDetail/getIssueDetail'
import getPublicDetail from '../../lib/api/dictDetail/getPublicDetail'
import getWoonginDetail from '../../lib/api/dictDetail/getWoonginDetail'
import getPhotoDictionary from '../../lib/api/dictionary/getPhotoDictionary'
import { dictArr, dictNameArr } from '../../lib/utils/dictArr'
import { AppDispatch, AppThunk } from '../store'

type WjpediaDetailState = {
  isLoading: boolean
  isError: boolean
  errorMessage: string
  result: any
  photoDict: any[]
  photoDictCnt: number
  dictUniqId: string
}

const initialState: WjpediaDetailState = {
  isLoading: false,
  isError: false,
  errorMessage: '',
  result: null,
  photoDict: [], // 포토백과 라이트 결과
  photoDictCnt: 0, // 포토백과 라이트 검색결과 카운트
  dictUniqId: '', // 상세 조회 dictUniqId -> 중복 호출 방지를 위해 추가
}

const wjpediaDetailSlice = createSlice({
  name: 'wjpediaDetail',
  initialState,
  reducers: {
    getWjpediaDetailStart: (state) => {
      // 요청 시작
      state.isLoading = true
    },
    getWjpediaDetailEnd: (state) => {
      // 요청 끝
      state.isLoading = false
    },
    getWjpediaDetailError: (state, action) => {
      // 에러 발생
      state.isError = true
      state.isLoading = false
      state.errorMessage = action.payload
      state.result = action.payload
    },
    getWjpediaDetailClear: (state) => {
      // clear
      state.result = null
      state.dictUniqId = ''
    },
    setDetailContents: (state, action) => {
      // 데이터 저장
      state.result = action.payload
    },
    setPhotoDictCnt: (state, action) => {
      state.photoDictCnt = action.payload
    },
    setPhotoDictContents: (state, action) => {
      state.photoDict = action.payload
    },
    setDictUniqId: (state, action) => {
      state.dictUniqId = action.payload
    },
  },
})

export const fetchDictDetail =
  (dictIdx: number, dictUniqId: string, sense_no: boolean): AppThunk =>
  //@ts-ignore
  async (dispatch: AppDispatch) => {
    try {
      dispatch(getWjpediaDetailStart())
      dispatch(setDictUniqId(dictUniqId))
      let result = null
      if (
        dictNameArr[dictIdx] === '관광사진정보' ||
        dictNameArr[dictIdx] === '유물정보' ||
        dictNameArr[dictIdx] === '문화재정보' ||
        dictNameArr[dictIdx] === '왕실유물정보' ||
        dictNameArr[dictIdx] === '어린이생물도감' ||
        dictNameArr[dictIdx] === '식물도감' ||
        dictNameArr[dictIdx] === '국가기본정보' ||
        dictNameArr[dictIdx] === '자연사정보' ||
        dictNameArr[dictIdx] === '3D백과' ||
        dictNameArr[dictIdx] === '우리말샘' ||
        dictNameArr[dictIdx] === '미술백과' ||
        dictNameArr[dictIdx] === '해양생물종정보' ||
        dictNameArr[dictIdx] === '궁궐종묘정보' ||
        dictNameArr[dictIdx] === '공룡' ||
        dictNameArr[dictIdx] === '별자리' ||
        dictNameArr[dictIdx] === '야생화' ||
        dictNameArr[dictIdx] === '곤충' ||
        dictNameArr[dictIdx] === '카메라'
      ) {
        result = await getPublicDetail(dictArr[dictIdx].dictCd, dictUniqId)
      }
      // 웅진학습백과
      else if (dictNameArr[dictIdx] === '웅진학습백과') {
        result = await getWoonginDetail(dictUniqId, 'wjpediaDetailSearchUri')
        // 웅진학습백과 -> 포토백과 lite 검색 조회 추가
        console.log(">>>>")

        var photoDict = await getPhotoDictionary(
          result.headwd,
          result.eduCtgrDetail.myArrayList?.map((eduCtgr: any) => eduCtgr?.map?.ctgr_no).join(',')
        )
  console.log(photoDict,">>>>")
        if (photoDict) {
          dispatch(setPhotoDictCnt(photoDict.photoDictCnt))
          dispatch(setPhotoDictContents(photoDict.photoDictContents))
        }
      }
      // 국어사전
      else if (dictNameArr[dictIdx] === '국어사전') {
        if (sense_no) {
          result = await getWoonginDetail(dictUniqId, 'stKorDictSenseUri')
        } else {
          result = await getWoonginDetail(dictUniqId, 'stKorDictUri')
        }
      }
      // 시사상식
      else if (dictNameArr[dictIdx] === '시사상식') {
        result = await getWoonginDetail(dictUniqId, 'senseDetailSearchUri')
      }
      // 수학사전
      else if (dictNameArr[dictIdx] === '수학사전') {
        result = await getWoonginDetail(dictUniqId, 'mathDetailSearchUri')
      }
      // 어린이 시사사전
      else if (dictNameArr[dictIdx] === '어린이 시사사전') {
        result = await getIssueDetail(dictUniqId, 'issueDetailSearchUri')
      }
      // 역사탐방정보
      else if (dictNameArr[dictIdx] === '역사탐방정보') {
        result = await getWoonginDetail(dictUniqId, 'modernDetailSearchUri')
      }

      if (result.result?.map?.status === 'BAD_GATEWAY') throw new Error('BAD_GATEWAY')

      dispatch(setDetailContents(result))
      dispatch(getWjpediaDetailEnd())
    } catch (e: any) {
        // console.log(e)
        dispatch(getWjpediaDetailError(e.message))
    }
  }

export const {
  getWjpediaDetailStart,
  getWjpediaDetailEnd,
  getWjpediaDetailError,
  getWjpediaDetailClear,
  setDetailContents,
  setPhotoDictCnt,
  setPhotoDictContents,
  setDictUniqId,
} = wjpediaDetailSlice.actions

export default wjpediaDetailSlice.reducer
